import TableCellDescription from "ds/components/Table/Row/CellDescription";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const DescriptionCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  return (
    <EnvironmentTableCell {...cellProps}>
      <TableCellDescription description={item.element.description} />
    </EnvironmentTableCell>
  );
};

export default DescriptionCell;
